import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      {
        subheader: 'ABOUT ME',
        items: [
          {
            title: 'Home',
            path: '/',
          },
          {
            title: 'About Me',
            path: paths.about,
          },
          {
            title: 'Contact',
            path: paths.contact,
          },
          {
            title: 'Services',
            path: paths.service,
          },

          {
            title: 'Certificate',
            path: paths.certification,
          },
          {
            title: 'Experience',
            path: paths.experience,
          },
          {
            title: 'Skills',
            path: paths.skills,
          },
        ],
      },
      {
        subheader: 'Explore FAQs',
        items: [{ title: 'FAQs', path: paths.faqs }],
      },
      {
        subheader: 'BLOG / ARTICLES',
        items: [{ title: 'Post', path: paths.post.root }],
      },
    ],
    []
  );

  return data;
}
